export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TeamMember.vue?vue&type=template&id=1ed6da48&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TeamMember.vue?vue&type=template&id=1ed6da48&scoped=true&
// module id = 95
// module chunks = 0